import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromDatasetsStore from './datasets-store.reducer';
import { Dataset } from '../models/dataset';

export const selectDatasetsStoreState = createFeatureSelector<fromDatasetsStore.State>(fromDatasetsStore.datasetsStoreFeatureKey);

export const selectDatasetsVM = createSelector(selectDatasetsStoreState, (state) => {
    const datasets = [...state.datasets];
    const filterValue = state.filterValue;
    const filterSampleTypes = state.filterSampleTypes;
    const filterSortColumn = state.filterSortColumn;
    const filterSortDirection = state.filterSortDirection;
    // sort datasets by filterSortColumn and filterSortDirection
    const sortedDatasets = datasets.sort((a, b) => {
        const valA = a[filterSortColumn];
        const valB = b[filterSortColumn];
        if (valA < valB) {
            return filterSortDirection === 'asc' ? -1 : 1;
        } else if (valA > valB) {
            return filterSortDirection === 'asc' ? 1 : -1;
        } else {
            return 0;
        }
    });

    const filteredDatasets = filter({ filterValue, filterSampleTypes }, sortedDatasets).map((dataset) => {
        return {
            ...dataset,
            expanded: false,
        };
    });

    return {
        datasets: filteredDatasets,
    };
});

const replaceSpecialCharacter = (val: string) => {
    let result = val;

    if (val.includes('Ö')) {
        result = val.replace('Ö', 'O');
    }

    if (val.includes('Š')) {
        result = val.replace('Š', 'S');
    }

    return result;
};

const filter = ({ filterValue, filterSampleTypes }: { filterValue: string; filterSampleTypes: number[] }, datasets: Dataset[]) => {
    let set = [...datasets];
    if (filterSampleTypes.length > 0) {
        set = set.filter((dataset) =>
            filterSampleTypes.find(
                (sampleType) =>
                    dataset.sampleTypes
                        .split(',')
                        .map((x) => +x)
                        .indexOf(sampleType) >= 0
            )
        );
    }

    if (filterValue) {
        set = set.filter(
            (dataset) =>
                dataset.displayText
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .toUpperCase()
                    .indexOf(filterValue.toUpperCase()) != -1 || dataset.displayText.toUpperCase().indexOf(filterValue.toUpperCase()) != -1
        );
    }

    return set;
};
